import React, { useEffect, useState } from 'react';
import apiClient from '../api/client';
const states: any = {
  PENDING: 'Pendiente',
  ACCEPTED: 'Aceptado',
  OBSERVED: 'Observado',
  REJECTED: 'Rechazado',
};
export default function PortalMedicalCertificates({
  busy,
  error,
}: {
  busy: (x: string) => void;
  error: (x: string) => void;
}) {
  const [items, setItems] = useState<any[]>([]),
    [leaves, setLeaves] = useState<any[]>([]),
    [show, setShow] = useState(false),
    [file, setFile] = useState<File | null>(null),
    [form, setForm] = useState<any>({
      leaveRequestId: '',
      careDate: '',
      restStartDate: '',
      expectedEndDate: '',
      provider: '',
      licenseNumber: '',
      employeeObservation: '',
      diagnosis: '',
    });
  const load = async () => {
    try {
      const [c, l] = await Promise.all([
        apiClient.get('/employee-portal/medical-certificates'),
        apiClient.get('/employee-portal/leaves'),
      ]);
      setItems(c.data);
      const medicalLeaves = l.data.filter((item: any) => item.leaveType.name === 'Ausencia');
      setLeaves(medicalLeaves);
      setForm((x: any) => ({
        ...x,
        leaveRequestId: x.leaveRequestId || medicalLeaves[0]?.id || '',
      }));
    } catch {
      error('No se pudieron cargar tus certificados médicos.');
    }
  };
  useEffect(() => {
    void load();
  }, []);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!file) return error('Seleccioná el archivo del certificado.');
    busy('Cargando certificado…');
    try {
      const d = new FormData();
      Object.entries(form).forEach(([k, v]) => {
        if (v) d.append(k, String(v));
      });
      d.append('file', file);
      await apiClient.post('/employee-portal/medical-certificates', d, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setShow(false);
      setFile(null);
      await load();
    } catch (e: any) {
      error(e.response?.data?.message || 'No se pudo cargar el certificado.');
    } finally {
      busy('');
    }
  };
  const open = async (x: any) => {
    busy('Abriendo certificado…');
    try {
      const r = await apiClient.get(`/employee-portal/medical-certificates/${x.id}/file`, {
          responseType: 'blob',
        }),
        url = URL.createObjectURL(r.data);
      window.open(url, '_blank', 'noopener,noreferrer');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch {
      error('No se pudo abrir el certificado.');
    } finally {
      busy('');
    }
  };
  return (
    <section className="portal-leaves">
      <div className="portal-section-head">
        <div>
          <h2>Certificados médicos</h2>
          <p>Archivos y datos protegidos de acceso restringido.</p>
        </div>
        <button className="portal-primary" onClick={() => setShow(!show)}>
          Cargar certificado
        </button>
      </div>
      {show && (
        <form className="portal-leave-form" onSubmit={submit}>
          <label>
            Licencia relacionada
            <select
              required
              value={form.leaveRequestId}
              onChange={(e) => setForm({ ...form, leaveRequestId: e.target.value })}
            >
              {leaves.map((x) => (
                <option value={x.id}>
                  {x.leaveType.name} · {String(x.startAt).slice(0, 10)}
                </option>
              ))}
            </select>
          </label>
          <label>
            Fecha de atención
            <input
              required
              type="date"
              value={form.careDate}
              onChange={(e) => setForm({ ...form, careDate: e.target.value })}
            />
          </label>
          <label>
            Inicio del reposo
            <input
              required
              type="date"
              value={form.restStartDate}
              onChange={(e) => setForm({ ...form, restStartDate: e.target.value })}
            />
          </label>
          <label>
            Finalización prevista
            <input
              required
              type="date"
              value={form.expectedEndDate}
              onChange={(e) => setForm({ ...form, expectedEndDate: e.target.value })}
            />
          </label>
          <label>
            Profesional o institución
            <input
              required
              value={form.provider}
              onChange={(e) => setForm({ ...form, provider: e.target.value })}
            />
          </label>
          <label>
            Matrícula
            <input
              value={form.licenseNumber}
              onChange={(e) => setForm({ ...form, licenseNumber: e.target.value })}
            />
          </label>
          <label>
            Observación presentada
            <textarea
              value={form.employeeObservation}
              onChange={(e) => setForm({ ...form, employeeObservation: e.target.value })}
            />
          </label>
          <label>
            Diagnóstico (opcional y restringido)
            <textarea
              value={form.diagnosis}
              onChange={(e) => setForm({ ...form, diagnosis: e.target.value })}
            />
          </label>
          <label>
            Archivo PDF/JPG/PNG
            <input
              required
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
            />
          </label>
          <div>
            <button type="button" className="portal-secondary" onClick={() => setShow(false)}>
              Cancelar
            </button>
            <button className="portal-primary">Enviar</button>
          </div>
        </form>
      )}
      <div className="portal-documents">
        {items.map((x) => (
          <article key={x.id}>
            <div className="receipt-icon">MED</div>
            <div className="receipt-info">
              <span>{states[x.status]}</span>
              <strong>{x.provider}</strong>
              <small>
                Reposo: {String(x.restStartDate).slice(0, 10)} –{' '}
                {String(x.expectedEndDate).slice(0, 10)}
              </small>
            </div>
            <button className="portal-secondary" onClick={() => void open(x)}>
              Ver certificado
            </button>
          </article>
        ))}
      </div>
    </section>
  );
}
